import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { IRole } from '@roles/models/IRole';

@Component({
  selector: 'app-role-list',
  templateUrl: './role-list.component.html',
  styleUrls: ['./role-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoleListComponent implements OnInit {
  @Input() roles: string[] = [];
  @Input() permissions: string[] = [];
  @Input() rolesWithPermissions: IRole = {};

  ngOnInit() {}
}
